import { COLORS } from '@btime/constants'
import { concatIf } from '@btime/helpers'
import { useFilter } from '@btime/react-contexts'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import {
  useOpenEditFieldsModal,
  useOpenExportHistoryModal,
  useOpenExportModal,
  useOpenImportHistoryModal,
  useOpenRoutinesModal,
  useOpenPublicTokensModal,
  useOpenSemaphoreConfigModal,
  useOpenTemplatesModal,
  useOpenTriggersModal
} from '../../../utils/routes/modals/modalsActions'
import { useTypeTranslation } from '../../places/_context/PlaceTypeContext'
import DropdownLink from '../../../components/navigation/DropdownLink'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const PageHeader = () => {
  const openTriggersModal = useOpenTriggersModal()
  const openEditFieldsModal = useOpenEditFieldsModal()
  const openImportHistoryModal = useOpenImportHistoryModal()
  const openExportModal = useOpenExportModal()
  const openExportHistoryModal = useOpenExportHistoryModal()
  const openTemplatesModal = useOpenTemplatesModal()
  const openSemaphoreConfigModal = useOpenSemaphoreConfigModal()
  const openRoutinesModal = useOpenRoutinesModal()

  const filter = useFilter()

  const { t } = useTypeTranslation(['common', 'listPlaces'])
  const navigate = useNavigation()

  const canListTriggers = useSessionPermission('listTrigger')
  const canListRoutines = useSessionPermission('listRoutine')
  const canExport = useSessionPermission('exportServiceOrder')
  const canImport = useSessionPermission('importServiceOrder')
  const canEdit = useSessionPermission('editServiceOrder')
  const canSetup = useSessionPermission('setupServiceOrder')
  const canListTemplate = useSessionPermission('listTemplate')
  const canListPublicToken = useSessionPermission('listPublicToken')
  const openPublicTokensModal = useOpenPublicTokensModal()
  const isOwner = useIsOwner()

  const options = [
    ...concatIf(canListTriggers, [
      {
        value: 'triggers',
        iconLeft: 'RiRobotLine',
        onClick: () =>
          openTriggersModal({
            entities: [
              'service_order',
              'event',
              'reply',
              'service_order_reply',
              'service_order_tag_assigned',
              'service_order_tag_removed'
            ]
          })
      },

      {
        value: 'integrations',
        iconLeft: 'RiPlugLine',
        onClick: () => openTriggersModal({ entities: ['service_order', 'event', 'reply'], integrationsOnly: true })
      },

      { line: true }
    ]),
    ...concatIf(canListRoutines, [
      {
        value: 'routines',
        iconLeft: 'RiCalendar2Line',
        onClick: () => openRoutinesModal({ entities: ['service_order'] })
      },
      { line: true }
    ]),

    ...concatIf(canListTemplate, [
      {
        value: 'templates',
        iconLeft: 'RiFileCopy2Line',
        onClick: () => openTemplatesModal('service_order')
      },

      { line: true }
    ]),

    ...concatIf(canImport, [
      {
        value: 'import',
        iconLeft: 'RiUploadCloud2Line',
        onClick: () => navigate(`/import/v2/serviceOrder`)
      },
      {
        value: 'importHistory',
        iconLeft: 'RiTimeLine',
        onClick: () => openImportHistoryModal('serviceOrder')
      },

      { line: true }
    ]),

    ...concatIf(canExport, [
      {
        value: 'export',
        iconLeft: 'RiDownloadCloud2Line',
        onClick: () => openExportModal({ entity: 'serviceOrder', filter })
      },

      {
        value: 'exportHistory',
        iconLeft: 'RiTimeLine',
        onClick: () => openExportHistoryModal('serviceOrder')
      },
      { line: true }
    ]),

    ...concatIf(canListPublicToken, [
      {
        value: 'publicToken',
        iconLeft: 'BsReply',
        onClick: () => openPublicTokensModal('service_order')
      },

      { line: true }
    ]),

    ...concatIf(canSetup, [
      {
        value: 'semaphore',
        iconLeft: 'RiAlarmWarningLine',
        onClick: () => openSemaphoreConfigModal({ name: 'service_order_started_since_colors' })
      },
      {
        value: 'fields',
        iconLeft: 'RiListSettingsLine',
        onClick: () => openEditFieldsModal('service_orders')
      }
    ])
  ]

  return (
    <>
      <Grid justify="space-between" align="center" gutter={0.8}>
        <Col>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('listServiceOrdersHistory:title')}
          </Title>
        </Col>
      </Grid>
      <Separator weight={2} />
    </>
  )
}

export default PageHeader
